import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle } from 'react-accessible-accordion';
import { convertDateToDayMonthYear, convertTime } from '../../../../lib/formatDate';
import Immutable from 'immutable';
import TradeRequestModal from '../../../shared/modal/TradeRequestModal';
import Button from '../../../shared/form/_Button';
import moment from 'moment';
import { connect } from 'react-redux';
import appointmentAPI from '../../../../sources/api/appointmentAPI';

const OthersOffersMobile = ({ othersOffers, showModal, modals, openFrequencyModal }) => {
  const _handleShowTradeRequestModal = (offer) => () => {
    appointmentAPI.verifyLimit({ id: offer.getIn(['appointment', 'id']) })
      .then(() => showModal(`tradeRequestModal${offer.get('id')}`))
      .catch(() => openFrequencyModal());
  };

  const isModalActive = (id) => modals && modals.getIn([id, 'active']);

  const formatScheduledOn = (offer) =>
    moment(offer.getIn(['appointment', 'scheduledOn']), 'YYYY-MM-DD').startOf('day').add(offer.getIn(['appointment', 'from']), 'seconds');

  return (
    <Accordion accordion={ false }>
      { othersOffers.valueSeq().map((offer) => (
        <Fragment key={ offer.get('id') }>
          <AccordionItem >
            <AccordionItemTitle>
              <div className='u-position-relative'>
                <div>
                  <div className={ 'accordion-header__title' }>Offerer</div>
                  <div className={ 'accordion-header__item' }>{offer.getIn(['offerer', 'name'])}</div>
                </div>
                <div>
                  <div className={ 'accordion-header__title' }>Offered Appt</div>
                  <div className={ 'accordion-header__item' }>{convertDateToDayMonthYear(offer.getIn(['appointment', 'scheduledOn']))}{' '}
                    {convertTime(offer.getIn(['appointment', 'from']))}</div>
                </div>
                <div>
                  <div className={ 'accordion-header__title' }>Office</div>
                  <div className={ 'accordion-header__item' }>{offer.getIn(['appointment', 'office', 'name'])}</div>
                </div>
                <div className='accordion__arrow' role='presentation' />
              </div>
            </AccordionItemTitle>
            <AccordionItemBody>
              <div>
                <div className={ 'trade-post__buttons' }>
                  <Button className='trade-post__accept-button' onClick={ _handleShowTradeRequestModal(offer) }>Trade Request</Button>
                </div>
              </div>
            </AccordionItemBody>
          </AccordionItem>
          {isModalActive(`tradeRequestModal${offer.get('id')}`) && <TradeRequestModal id={ `tradeRequestModal${offer.get('id')}` }
            rep={ offer.getIn(['offerer']) }
            requestedAppointmentId={ offer.getIn(['appointment', 'id']) }
            requestedAppointmentScheduledOn={ formatScheduledOn(offer) } />}
        </Fragment>
      ))}
    </Accordion>

  );
};

OthersOffersMobile.propTypes = {
  modals: PropTypes.instanceOf(Immutable.Map),
  openFrequencyModal: PropTypes.func.isRequired,
  othersOffers: PropTypes.instanceOf(Immutable.Map).isRequired,
  showModal: PropTypes.func.isRequired
};
const mapStateToProps = (state) => ({ modals: state.getIn(['tooltip', 'data']) });

export default connect(mapStateToProps)(OthersOffersMobile);



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/offers/OthersOffersMobile.jsx